/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { EnrollmentStatus } from './EnrollmentStatus';
import {
    EnrollmentStatusFromJSON,
    EnrollmentStatusFromJSONTyped,
    EnrollmentStatusToJSON,
    EnrollmentStatusToJSONTyped,
} from './EnrollmentStatus';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ClassEnrollmentActivity
 */
export interface ClassEnrollmentActivity {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof ClassEnrollmentActivity
     */
    classEnrollmentId?: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof ClassEnrollmentActivity
     */
    action?: string;
    /**
     * 
     * @type {EnrollmentStatus}
     * @memberof ClassEnrollmentActivity
     */
    fromStatus?: EnrollmentStatus | null;
    /**
     * 
     * @type {EnrollmentStatus}
     * @memberof ClassEnrollmentActivity
     */
    toStatus?: EnrollmentStatus | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ClassEnrollmentActivity
     */
    actorUserId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof ClassEnrollmentActivity
     */
    actorEmail?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ClassEnrollmentActivity
     */
    occurredAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ClassEnrollmentActivity
     */
    requiresReview?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ClassEnrollmentActivity
     */
    reviewedAt?: Date | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ClassEnrollmentActivity
     */
    reviewedByUserId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof ClassEnrollmentActivity
     */
    reviewedByEmail?: string | null;
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof ClassEnrollmentActivity
     */
    id?: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ClassEnrollmentActivity
     */
    tenantId?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Date}
     * @memberof ClassEnrollmentActivity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClassEnrollmentActivity
     */
    updatedAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ClassEnrollmentActivity
     */
    updatedBy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassEnrollmentActivity
     */
    createdBy?: string | null;
}



/**
 * Check if a given object implements the ClassEnrollmentActivity interface.
 */
export function instanceOfClassEnrollmentActivity(value: object): value is ClassEnrollmentActivity {
    return true;
}

export function ClassEnrollmentActivityFromJSON(json: any): ClassEnrollmentActivity {
    return ClassEnrollmentActivityFromJSONTyped(json, false);
}

export function ClassEnrollmentActivityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassEnrollmentActivity {
    if (json == null) {
        return json;
    }
    return {
        
        'classEnrollmentId': json['classEnrollmentId'] == null ? undefined : ApiUserTasksGetLastSelectedIdParameterFromJSON(json['classEnrollmentId']),
        'action': json['action'] == null ? undefined : json['action'],
        'fromStatus': json['fromStatus'] == null ? undefined : EnrollmentStatusFromJSON(json['fromStatus']),
        'toStatus': json['toStatus'] == null ? undefined : EnrollmentStatusFromJSON(json['toStatus']),
        'actorUserId': json['actorUserId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['actorUserId']),
        'actorEmail': json['actorEmail'] == null ? undefined : json['actorEmail'],
        'occurredAt': json['occurredAt'] == null ? undefined : (new Date(json['occurredAt'])),
        'requiresReview': json['requiresReview'] == null ? undefined : json['requiresReview'],
        'reviewedAt': json['reviewedAt'] == null ? undefined : (new Date(json['reviewedAt'])),
        'reviewedByUserId': json['reviewedByUserId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['reviewedByUserId']),
        'reviewedByEmail': json['reviewedByEmail'] == null ? undefined : json['reviewedByEmail'],
        'id': json['id'] == null ? undefined : ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
        'tenantId': json['tenantId'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['tenantId']),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
    };
}

export function ClassEnrollmentActivityToJSON(json: any): ClassEnrollmentActivity {
    return ClassEnrollmentActivityToJSONTyped(json, false);
}

export function ClassEnrollmentActivityToJSONTyped(value?: ClassEnrollmentActivity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classEnrollmentId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['classEnrollmentId']),
        'action': value['action'],
        'fromStatus': EnrollmentStatusToJSON(value['fromStatus']),
        'toStatus': EnrollmentStatusToJSON(value['toStatus']),
        'actorUserId': ActorActivityRecordActorUserIdToJSON(value['actorUserId']),
        'actorEmail': value['actorEmail'],
        'occurredAt': value['occurredAt'] == null ? value['occurredAt'] : value['occurredAt'].toISOString(),
        'requiresReview': value['requiresReview'],
        'reviewedAt': value['reviewedAt'] == null ? value['reviewedAt'] : value['reviewedAt'].toISOString(),
        'reviewedByUserId': ActorActivityRecordActorUserIdToJSON(value['reviewedByUserId']),
        'reviewedByEmail': value['reviewedByEmail'],
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
        'tenantId': ApiUserTasksGetPageParameterToJSON(value['tenantId']),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'updatedBy': value['updatedBy'],
        'createdBy': value['createdBy'],
    };
}

